// extracted by mini-css-extract-plugin
export default {"settings":"settings_settings__e6Jb8","settings__bottom":"settings_settings__bottom__Sibtp"};